import { ButtonParticipantMicrophone } from '@/components/ButtonParticipantMicrophone'
import { ButtonParticipantVideo } from '@/components/ButtonParticipantVideo'
import { useAllMemberMicrophoneButtonState } from '@/hooks/useAllMemberMicrophoneButtonState'
import { useMemberMicrophoneButtonState } from '@/hooks/useMemberMicrophoneButtonState'
import { useMemberVideoButtonState } from '@/hooks/useMemberVideoButtonState'
import { useOptimisticUpdateWithPromise } from '@/hooks/useOptimisticUpdateWithPromise'
import { useRoomStoreActions } from '@/stores/room'

export const AllMemberMicrophoneButton = () => {
  const { isAllMembersMuted, isMicrophoneButtonVisible, isMicrophoneEnabled } =
    useAllMemberMicrophoneButtonState()
  const { audioMuteAllHandler } = useRoomStoreActions()

  const { optimisticValue, handleUpdate } = useOptimisticUpdateWithPromise(
    isAllMembersMuted,
    audioMuteAllHandler,
  )

  const handleToggleMute = () => {
    handleUpdate(!isAllMembersMuted)
  }

  return (
    <ButtonParticipantMicrophone
      audioMuted={optimisticValue}
      isMicrophoneButtonVisible={isMicrophoneButtonVisible}
      isMicrophoneEnabled={isMicrophoneEnabled}
      onToggleMute={handleToggleMute}
      participantName="all participants"
    />
  )
}

interface MemberMicrophoneButtonProps {
  audioMuted: boolean
  participantId: string
  participantName: string
}

const MemberMicrophoneButton = ({
  audioMuted,
  participantId,
  participantName,
}: MemberMicrophoneButtonProps) => {
  const { isMicrophoneButtonVisible, isMicrophoneEnabled } =
    useMemberMicrophoneButtonState(participantId)

  const { audioMuteHandler } = useRoomStoreActions()

  const handleToggleMute = () => {
    audioMuteHandler(participantId)
  }

  return (
    <ButtonParticipantMicrophone
      audioMuted={audioMuted}
      isMicrophoneButtonVisible={isMicrophoneButtonVisible}
      isMicrophoneEnabled={isMicrophoneEnabled}
      onToggleMute={handleToggleMute}
      participantName={participantName}
    />
  )
}

interface MemberVideoButtonProps {
  participantId: string
  participantName: string
  videoMuted: boolean
}

const MemberVideoButton = ({
  participantId,
  participantName,
  videoMuted,
}: MemberVideoButtonProps) => {
  const { isVideoButtonVisible, isVideoEnabled } =
    useMemberVideoButtonState(participantId)

  const { videoMuteHandler } = useRoomStoreActions()

  const handleToggleVideo = () => {
    videoMuteHandler(participantId)
  }

  return (
    <ButtonParticipantVideo
      isVideoButtonVisible={isVideoButtonVisible}
      isVideoEnabled={isVideoEnabled}
      onToggleVideo={handleToggleVideo}
      participantName={participantName}
      videoMuted={videoMuted}
    />
  )
}

interface ParticipantMemberButtonsProps
  extends MemberMicrophoneButtonProps,
    MemberVideoButtonProps {}

export const ParticipantMemberButtons = ({
  audioMuted,
  participantId,
  participantName,
  videoMuted,
}: ParticipantMemberButtonsProps) => {
  return (
    <>
      <MemberMicrophoneButton
        audioMuted={audioMuted}
        participantId={participantId}
        participantName={participantName}
      />
      <MemberVideoButton
        participantId={participantId}
        participantName={participantName}
        videoMuted={videoMuted}
      />
    </>
  )
}
